import { render, staticRenderFns } from "./SupportSection.vue?vue&type=template&id=39625efc&scoped=true&"
import script from "./SupportSection.vue?vue&type=script&lang=js&"
export * from "./SupportSection.vue?vue&type=script&lang=js&"
import style0 from "./SupportSection.vue?vue&type=style&index=0&id=39625efc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39625efc",
  null
  
)

export default component.exports